document.documentElement.classList.remove('no-js');

(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Mobile nav ---------- */
  var burger = qs('[data-mobile-nav-toggle]');
  var mobileNav = qs('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var isOpen = !mobileNav.hasAttribute('hidden');
      if (isOpen) {
        mobileNav.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      } else {
        mobileNav.removeAttribute('hidden');
        burger.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ---------- Explore mega-menu (touch / click support) ---------- */
  qsa('[data-explore-menu]').forEach(function (item) {
    var trigger = qs('.site-nav__link--button', item);
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---------- Search panel ---------- */
  var searchPanel = qs('[data-search-panel]');
  qsa('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchPanel) return;
      var isHidden = searchPanel.hasAttribute('hidden');
      if (isHidden) {
        searchPanel.removeAttribute('hidden');
        var input = qs('.search-panel__input', searchPanel);
        if (input) setTimeout(function () { input.focus(); }, 50);
      } else {
        searchPanel.setAttribute('hidden', '');
      }
    });
  });

  /* ---------- Featured products carousel ---------- */
  qsa('[data-carousel]').forEach(function (carousel) {
    var track = qs('[data-carousel-track]', carousel);
    var wrapper = carousel.closest('.featured-products') || carousel.parentElement;
    var prevBtn = wrapper ? qs('[data-carousel-prev]', wrapper) : null;
    var nextBtn = wrapper ? qs('[data-carousel-next]', wrapper) : null;
    if (!track || !prevBtn || !nextBtn) return;

    var index = 0;

    function visibleCount() {
      var w = window.innerWidth;
      if (w <= 480) return 1;
      if (w <= 700) return 2;
      if (w <= 1000) return 3;
      return 5;
    }

    function maxIndex() {
      var total = qsa('.carousel__slide', track).length;
      return Math.max(0, total - visibleCount());
    }

    function update() {
      var slide = qs('.carousel__slide', track);
      if (!slide) return;
      var slideWidth = slide.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24;
      var offset = index * (slideWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    nextBtn.addEventListener('click', function () {
      index = Math.min(index + visibleCount(), maxIndex());
      update();
    });
    prevBtn.addEventListener('click', function () {
      index = Math.max(index - visibleCount(), 0);
      update();
    });
    window.addEventListener('resize', function () {
      index = Math.min(index, maxIndex());
      update();
    });
    update();
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = qs('[data-cart-drawer]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  qsa('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (cartDrawer && cartDrawer.hasAttribute('data-open')) {
        closeCart();
      } else {
        e.preventDefault();
        openCart();
      }
    });
  });

  function refreshCartDrawer() {
    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          bindCartDrawerEvents();
        }
      })
      .catch(function () {});
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });
      })
      .catch(function () {});
  }

  function bindCartDrawerEvents() {
    if (!cartDrawer) return;
    qsa('[data-cart-toggle]', cartDrawer).forEach(function (el) {
      el.addEventListener('click', closeCart);
    });
    qsa('[data-cart-remove]', cartDrawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.closest('[data-cart-line]');
        var key = line ? line.dataset.cartLine : null;
        var index = line ? Array.prototype.indexOf.call(line.parentElement.children, line) + 1 : null;
        if (!index) return;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: index, quantity: 0 })
        }).then(refreshCartDrawer);
      });
    });
    qsa('[data-qty-stepper]', cartDrawer).forEach(function (stepper) {
      var line = stepper.closest('[data-cart-line]');
      if (!line) return;
      var index = Array.prototype.indexOf.call(line.parentElement.children, line) + 1;
      var valueEl = qs('[data-qty-value]', stepper);
      qs('[data-qty-increase]', stepper).addEventListener('click', function () {
        var qty = parseInt(valueEl.textContent, 10) + 1;
        changeLine(index, qty);
      });
      qs('[data-qty-decrease]', stepper).addEventListener('click', function () {
        var qty = Math.max(0, parseInt(valueEl.textContent, 10) - 1);
        changeLine(index, qty);
      });
    });
  }

  function changeLine(index, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: index, quantity: qty })
    }).then(refreshCartDrawer);
  }

  bindCartDrawerEvents();

  /* ---------- Add to cart / Buy now (AJAX) ---------- */
  var productForm = qs('#ProductForm');
  if (productForm) {
    var addToCartBtn = qs('button[type="submit"]:not([data-buy-now])', productForm);
    var buyNowBtn = qs('button[data-buy-now]', productForm);

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var isBuyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
      var formData = new FormData(productForm);
      var btn = isBuyNow ? buyNowBtn : addToCartBtn;
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = isBuyNow ? 'Redirecting…' : 'Adding…'; btn.disabled = true; }
      if (addToCartBtn && addToCartBtn !== btn) addToCartBtn.disabled = true;
      if (buyNowBtn && buyNowBtn !== btn) buyNowBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }
          refreshCartDrawer();
          openCart();
        })
        .catch(function () {})
        .finally(function () {
          if (!isBuyNow && btn) { btn.textContent = originalText; btn.disabled = false; }
          if (!isBuyNow) {
            if (addToCartBtn) addToCartBtn.disabled = false;
            if (buyNowBtn) buyNowBtn.disabled = false;
          }
        });
    });

    /* Product page quantity stepper */
    var qtyStepper = qs('.product__form [data-qty-stepper]');
    if (qtyStepper) {
      var qtyInput = qs('[data-qty-value]', qtyStepper);
      qs('[data-qty-increase]', qtyStepper).addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) + 1);
      });
      qs('[data-qty-decrease]', qtyStepper).addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1);
      });
    }

    /* Variant selection */
    var variantsScript = qs('[data-product-variants]', productForm);
    var variantIdInput = qs('[data-variant-id]', productForm);
    var optionSelectors = qsa('.option-selector', productForm);
    if (variantsScript && variantIdInput && optionSelectors.length) {
      var variants = JSON.parse(variantsScript.textContent);
      function findVariant() {
        var selected = optionSelectors.map(function (sel) { return sel.value; });
        var match = variants.find(function (v) {
          var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
          return selected.every(function (val, i) { return opts[i] === val; });
        });
        if (match) {
          variantIdInput.value = match.id;
          if (addToCartBtn) {
            addToCartBtn.disabled = !match.available;
            addToCartBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
          }
          if (buyNowBtn) buyNowBtn.disabled = !match.available;
        }
      }
      optionSelectors.forEach(function (sel) { sel.addEventListener('change', findVariant); });
    }
  }

  /* ---------- Product image gallery ---------- */
  var mainImage = qs('#ProductMainImage');
  var galleryThumbs = qsa('[data-product-thumb]');
  var galleryIndex = 0;

  function setGalleryImage(index) {
    if (!galleryThumbs.length) return;
    galleryIndex = (index + galleryThumbs.length) % galleryThumbs.length;
    var thumb = galleryThumbs[galleryIndex];
    if (mainImage && mainImage.tagName === 'IMG') mainImage.src = thumb.dataset.full;
    galleryThumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  galleryThumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { setGalleryImage(i); });
  });
  var galleryPrev = qs('[data-gallery-prev]');
  var galleryNext = qs('[data-gallery-next]');
  if (galleryPrev) galleryPrev.addEventListener('click', function () { setGalleryImage(galleryIndex - 1); });
  if (galleryNext) galleryNext.addEventListener('click', function () { setGalleryImage(galleryIndex + 1); });
})();
